import { MediaFileService } from '../../data/media-file.service.ts'
import type { UUID } from '@/features/shared/data/string.types.ts'

const waitUntilProcessed = async (fileId: string): Promise<void> => {
  const { status } = await MediaFileService.getFileInfo(fileId)
  if (status === 'uploaded') {
    return // all set here
  }
  if (status === 'file_derivation_failed') {
    // TODO: ask people on Audiostack about this
    throw new Error('File derivation failed')
  }
  await new Promise((resolve) => setTimeout(resolve, 2_000))
  await waitUntilProcessed(fileId)
}

export const uploadFile = async (
  file: File,
  folderId: UUID,
  fileName: string,
  categoryId: UUID,
  categoryName: string
): Promise<string> => {
  const uploadUrl = await MediaFileService.createUploadMediaFileUrl(
    folderId,
    fileName,
    categoryId,
    categoryName
  )

  await MediaFileService.uploadMediaFile(uploadUrl.uploadUrl, file)
  await waitUntilProcessed(uploadUrl.fileId)
  await MediaFileService.patchMediaFile(
    uploadUrl.fileId,
    fileName,
    categoryId,
    categoryName
  )
  return uploadUrl.fileId
}
